import React from 'react';
import { Itemset } from '../../store/viewmodels/ItemsetViewModel';
import { Task } from '../../store/viewmodels/TaskViewModel';

interface DualTaskItemSetSelectionProps {
    selectableTasks: Task[],
    itemset_access_list: number[]
    setItemsetIds: React.Dispatch<React.SetStateAction<number[]>>
    setTasksIds: React.Dispatch<React.SetStateAction<number[]>>
}

function DualTaskItemSetSelection(props: DualTaskItemSetSelectionProps): JSX.Element {
    const [selectedItemsetIds, setSelectedItemsetsIds] = React.useState<string[]>([]);
    const [studentsItemsets, setStudentsItemsets] = React.useState(props.itemset_access_list.map(id => id.toString()));
    const [selectedToRemove, setSelectedToRemove] = React.useState<string[]>([]);

    React.useEffect(() => {
        let itemsetIds: number[] = studentsItemsets.map(id => Number(id));
        props.setItemsetIds(itemsetIds);
        let taskIds = getStudentsTasks().map(task => task.id)
        props.setTasksIds(taskIds);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [studentsItemsets]);

    let selectableTasksOptions: JSX.Element[] = [];

    for (let i = 0; i < props.selectableTasks.length; i++) {
        let id = props.selectableTasks[i].id;
        let name = props.selectableTasks[i].name;
        let options: JSX.Element[] = [];

        for (let j = 0; j < props.selectableTasks[i].itemsets.length; j++) {

            let itemSet = props.selectableTasks[i].itemsets[j];


            if(itemSet.ready_to_publish === false) continue;
            if (studentsItemsets.includes(itemSet.id.toString())) continue;

            let option = <option key={"option" + itemSet.id + itemSet.name} value={itemSet.id} >{itemSet.name}</option>;
            options.push(option);
        }

        if (options.length === 0) continue;

        let optGroup = <optgroup label={name} key={"optgroup" + name + id}>{options}</optgroup>
        selectableTasksOptions.push(optGroup);
    }

    function getStudentsTasks(): Task[] {
        let studentsTasks: Task[] = [];

        for (let si = 0; si < studentsItemsets.length; si++) {
            let selectedItemsetId = studentsItemsets[si];

            for (let t = 0; t < props.selectableTasks.length; t++) {
                let task = props.selectableTasks[t];

                for (let i = 0; i < task.itemsets.length; i++) {
                    let itemset: Itemset = task.itemsets[i];
                    if (Number(selectedItemsetId) === itemset.id) {
                        if (!studentsTasks.includes(task)) {
                            studentsTasks.push(task);
                        }
                        break;
                    }
                }
            }
        }

        return studentsTasks;
    }

    let studentsTasksOptions = [];
    let studentsTasks: Task[] = getStudentsTasks();
    for (let i = 0; i < studentsTasks.length; i++) {
        let task = studentsTasks[i];

        let options: JSX.Element[] = [];
        for (let sis = 0; sis < studentsItemsets.length; sis++) {
            for (let is = 0; is < task.itemsets.length; is++) {
                let studentsItemsetId = studentsItemsets[sis];
                let possibleItemset = task.itemsets[is];
                if (Number(studentsItemsetId) === Number(possibleItemset.id)) {
                    let option = <></>;
                    if(possibleItemset.ready_to_publish === false) {
                        option = <option className="text-gray-300" key={"option" + possibleItemset.id + possibleItemset.name} value={possibleItemset.id} >{possibleItemset.name}</option>;
                    } else {
                        option = <option key={"option" + possibleItemset.id + possibleItemset.name} value={possibleItemset.id} >{possibleItemset.name}</option>;
                    }

                    options.push(option);
                }
            }
        }
        let theme: string = task.theme !== "NONE" ? task.theme : task.name;
        let optGroup = <optgroup label={theme} key={"optgroup" + task.name + task.id}>{options}</optgroup>
        studentsTasksOptions.push(optGroup);
    }

    function getSelected(options: any[]): string[] {
        const selected = [] as string[];
        for (let i = 0; i < options.length; i++) {
            if (options[i].selected) {
                selected.push(options[i].value);
            }
        }
        return selected;
    }

    const selectOnChange = (e: { target: { options: any; }; }) => {
        setSelectedItemsetsIds(getSelected(e.target.options));
    }

    const removeOnChange = (e: { target: { options: any; }; }) => {
        setSelectedToRemove(getSelected(e.target.options));
    }

    let selectableTasksSelection = (
        <div className="sm:w-2/4">
            <select className="w-full" name="taskSelection" value={selectedItemsetIds} multiple size={7} onChange={selectOnChange}>
                {selectableTasksOptions}
            </select>
        </div>
    );

    let studentsTasksSelection = (
        <div className="sm:w-2/4">
            <select className="w-full" name="studentsTaskSelection" value={selectedToRemove} multiple size={7} onChange={removeOnChange}>
                {studentsTasksOptions}
            </select>
        </div>
    );

    function upDateStudentsItemset(iterableArray: string[], comparableArray: string[]): string[] {
        let itemsets: string[] = [];
        for (let i = 0; i < iterableArray.length; i++) {
            if (!comparableArray.includes(iterableArray[i])) {
                itemsets.push(iterableArray[i]);
            }
        }

        return itemsets;
    }

    const handleAddClick = () => {
        let itemsets: string[] = upDateStudentsItemset(selectedItemsetIds, studentsItemsets);
        setStudentsItemsets(studentsItemsets.concat(itemsets));
        setSelectedItemsetsIds([]);
    }

    const handleRemoveClick = () => {
        let itemsets: string[] = upDateStudentsItemset(studentsItemsets, selectedToRemove);
        setStudentsItemsets(itemsets);
        setSelectedToRemove([]);
    }

    return (
        <div className="md:flex">
            {selectableTasksSelection}
            <div className="md:flex-column m-auto md:text-center">
                <button type="button" onClick={handleAddClick} className="m-auto text-3xl text-teal-500 hover:text-teal-400 ri-add-circle-line">
                </button>
                <button type="button" onClick={handleRemoveClick} className="m-auto text-3xl text-red-500 hover:text-red-400 ri-indeterminate-circle-line">
                </button>
            </div>
            {studentsTasksSelection}
        </div>
    );
}

export default DualTaskItemSetSelection;